import { resources } from "./common/messages";
import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import { config } from "./common/config";

const getLang = () => {
  const key = config?.localStorageNames?.lang;
  const saved = key && localStorage?.getItem?.(key);
  if (saved === "ru" || saved === "tm") return saved;
  key && localStorage?.setItem?.(key, "ru");
  return "ru";
};

i18n?.use?.(initReactI18next)?.init?.({
  resources,
  lng: getLang?.(),
  fallbackLng: ["tm", "ru"],
  supportedLngs: ["tm", "ru"],

  keySeparator: false,

  interpolation: { escapeValue: false },

  returnNull: false,
  returnEmptyString: true,

  react: { useSuspense: false },
});

export default i18n;
